import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import TopClinicalTrialsWrapper from "@components/layouts/topClinicalTrialsWrapper";

export default function TopClinicaltrialsHome(): ReactElement {
    return (
        <TopClinicalTrialsWrapper>
            <TermsAndConditions
                category="Clinical Trials"
                domain="TopClinicalTrials.com"
            />
        </TopClinicalTrialsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
